import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const articleImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20a%20minimalist%20laptop%20workspace%20from%20above%2C%20screen%20displaying%20colorful%20organized%20spreadsheet%20data%2C%20warm%20cream%20and%20terracotta%20desk%20with%20artisan%20coffee%20cup%20and%20handwritten%20notebook%2C%20soft%20natural%20daylight%20streaming%20from%20window%2C%20sage%20green%20accents%2C%20high-end%20lifestyle%20editorial%20photography%2C%20clean%20inviting%20atmosphere%2C%20storytelling%20composition%20with%20depth&width=1600&height=700&seq=article-hero-01&orientation=landscape",
  2: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20a%20brass%20padlock%20resting%20on%20warm%20textured%20cream%20surface%20with%20soft%20natural%20window%20light%2C%20subtle%20protective%20symbolism%20with%20sage%20green%20eucalyptus%20branch%2C%20minimalist%20security%20concept%20photography%2C%20shallow%20depth%20of%20field%2C%20elegant%20and%20trustworthy%20atmosphere%2C%20professional%20yet%20warm%20aesthetic&width=1600&height=700&seq=article-hero-02&orientation=landscape",
  3: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20designer%20sneakers%20and%20fashion%20accessories%20beautifully%20styled%20on%20warm%20cream%20surface%2C%20natural%20daylight%2C%20curated%20collection%20flatlay%2C%20catalog%20aesthetic%20with%20terracotta%20and%20sage%20green%20accents%2C%20magazine%20editorial%20quality%2C%20soft%20shadows%20and%20harmonious%20composition%2C%20lifestyle%20product%20photography&width=1600&height=700&seq=article-hero-03&orientation=landscape",
  4: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20split%20composition%20of%20messy%20desk%20with%20scattered%20papers%20versus%20clean%20organized%20desk%20with%20laptop%20and%20spreadsheet%2C%20warm%20earthy%20tones%2C%20natural%20daylight%2C%20storytelling%20contrast%20photography%2C%20modern%20workspace%20concept%2C%20cream%20and%20terracotta%20palette%20with%20sage%20green%20plant%20accents&width=1600&height=700&seq=article-hero-04&orientation=landscape",
  5: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20a%20kraft%20paper%20package%20with%20international%20shipping%20labels%20on%20warm%20cream%20surface%2C%20softly%20blurred%20world%20map%20in%20background%2C%20minimalist%20logistics%20concept%2C%20sage%20green%20plant%2C%20natural%20window%20light%2C%20modern%20ecommerce%20aesthetic%2C%20elegant%20and%20clean%20composition&width=1600&height=700&seq=article-hero-05&orientation=landscape",
  6: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20hands%20gently%20holding%20an%20open%20notebook%20with%20handwritten%20beginner%20tips%2C%20warm%20cream%20desk%20background%2C%20soft%20natural%20daylight%2C%20welcoming%20and%20inclusive%20atmosphere%2C%20sage%20green%20and%20terracotta%20accents%2C%20lifestyle%20photography%2C%20approachable%20tutorial%20concept&width=1600&height=700&seq=article-hero-06&orientation=landscape",
  7: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20top-down%20shot%20of%20organized%20fashion%20and%20lifestyle%20products%20in%20neat%20labeled%20grid%20sections%20on%20warm%20cream%20surface%2C%20systematic%20catalog%20concept%2C%20soft%20natural%20light%2C%20sage%20green%20accents%2C%20clean%20elegant%20arrangement%2C%20magazine%20editorial%20style%2C%20meticulous%20composition%20with%20gentle%20shadows&width=1600&height=700&seq=article-hero-07&orientation=landscape",
  8: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20macro%20shot%20of%20a%20magnifying%20lens%20examining%20fine%20fabric%20weave%20texture%20in%20warm%20cream%20tones%2C%20quality%20inspection%20concept%2C%20soft%20natural%20daylight%2C%20detail-oriented%20atmosphere%2C%20sage%20green%20accents%2C%20shallow%20depth%20of%20field%2C%20professional%20product%20photography%20aesthetic%2C%20clean%20sophisticated%20composition&width=1600&height=700&seq=article-hero-08&orientation=landscape",
  9: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20colorful%20question%20mark%20sticky%20notes%20artfully%20arranged%20on%20warm%20cream%20wall%2C%20FAQ%20knowledge%20concept%2C%20soft%20natural%20daylight%2C%20playful%20yet%20professional%20atmosphere%2C%20sage%20green%20potted%20plant%20element%2C%20clean%20minimalist%20composition%2C%20information%20and%20learning%20theme%20photography&width=1600&height=700&seq=article-hero-09&orientation=landscape",
  10: "https://readdy.ai/api/search-image?query=Wide%20editorial%20hero%20shot%20of%20elegant%20chess%20pieces%20on%20modern%20minimalist%20board%2C%20warm%20cream%20surface%2C%20soft%20window%20light%20creating%20gentle%20shadows%2C%20strategic%20thinking%20concept%2C%20sage%20green%20backdrop%2C%20thoughtful%20and%20calm%20atmosphere%2C%20clean%20sophisticated%20composition%2C%20depth%20of%20field%20focusing%20on%20a%20key%20piece&width=1600&height=700&seq=article-hero-10&orientation=landscape",
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.rest';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center">
        <h1 className="font-heading text-2xl text-foreground-900 mb-4">Artykuł nie został znaleziony</h1>
        <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">
          Wróć na stronę główną
        </Link>
      </div>
    );
  }

  const articleUrl = `${siteUrl}/artykul/${article.slug}`;
  const heroImage = articleImages[article.id];

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: heroImage,
    datePublished: article.date,
    dateModified: article.date,
    author: {
      '@type': 'Organization',
      name: 'Kakobuy Polska Spreadsheet',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Kakobuy Polska Spreadsheet',
      url: siteUrl,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': articleUrl,
    },
    inLanguage: 'pl',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Strona główna',
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: article.title,
        item: articleUrl,
      },
    ],
  };

  const paragraphs = article.content.split('\n\n').filter(Boolean);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <main className="pt-16">
        <article>
          <div className="relative w-full h-[300px] md:h-[420px] overflow-hidden">
            <img
              src={articleImages[article.id]}
              alt={article.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
          </div>

          <div className="max-w-[800px] mx-auto px-4 md:px-6 -mt-16 relative z-10">
            <div className="bg-background-50 rounded-lg p-6 md:p-10">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4">
                <span>{article.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{article.readTime}</span>
              </div>

              <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
                {article.title}
              </h1>

              <div className="flex flex-wrap items-center gap-2 mb-8">
                <span className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">
                  Kakobuy Spreadsheet
                </span>
                <span className="px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium">
                  Poradnik
                </span>
                <span className="px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium">
                  Polska
                </span>
              </div>

              <div className="prose-custom text-foreground-800 leading-relaxed">
                {paragraphs.map((paragraph, index) => {
                  if (paragraph.startsWith('## ')) {
                    return (
                      <h2 key={index} className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mt-8 mb-4">
                        {paragraph.replace('## ', '')}
                      </h2>
                    );
                  }
                  if (paragraph.startsWith('### ')) {
                    return (
                      <h3 key={index} className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mt-6 mb-3">
                        {paragraph.replace('### ', '')}
                      </h3>
                    );
                  }
                  if (paragraph.startsWith('- ')) {
                    const items = paragraph.split('\n').filter((item) => item.startsWith('- '));
                    return (
                      <ul key={index} className="list-disc list-inside space-y-1 mb-4 text-sm md:text-base text-foreground-700">
                        {items.map((item, i) => (
                          <li key={i}>{item.replace('- ', '')}</li>
                        ))}
                      </ul>
                    );
                  }
                  return (
                    <p key={index} className="mb-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                      {paragraph}
                    </p>
                  );
                })}
              </div>

              <div className="mt-10 p-6 bg-primary-50 rounded-lg border border-primary-200/50">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
                  Chcesz dowiedzieć się więcej?
                </h3>
                <p className="text-sm text-foreground-600 mb-4">
                  Sprawdź pełny Kakobuy Spreadsheet i znajdź tysiące produktów w jednym miejscu.
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Otwórz Kakobuy Spreadsheet
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>

              <div className="mt-8 pt-6 border-t border-background-200/70">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                  <span>Wróć na stronę główną</span>
                </Link>
              </div>
            </div>
          </div>
        </article>

        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">
              Gotowy na zakupy?
            </h2>
            <p className="text-sm text-foreground-600 mb-6 max-w-[500px] mx-auto">
              Przejdź do głównego serwisu i odkryj pełną listę produktów Kakobuy.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3 bg-accent-500 text-background-50 rounded-md text-base font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Kup teraz
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}